<svelte:head>
  <title>Recover password | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-label-has-associated-control -->
<!-- svelte-ignore a11y-missing-attribute -->

<section class="section hero is-fullheight is-error-section">
  <form on:submit|preventDefault={() => reset()}>
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-four-fifths-tablet is-three-fifths-desktop">
            <div class="section">
              <div class="container">
                <div class="card">
                  <div class="card-header">
                    <div class="card-header-title">Reset password</div>
                  </div>
                  <div class="card-content">
                    <div class="content">
                      <div class="field">
                        <label class="label">Email address</label>
                        <div class="control">
                          <input
                            class="input"
                            type="text"
                            placeholder=""
                            bind:value={email} />
                        </div>
                      </div>
                      <hr />
                      <div class="field is-grouped">
                        <div class="control">
                        <button class="button is-primary" type="submit">Reset
                          password</button>
                        </div>
                        <div class="control">
                          <a href="/" class="button is-outlined">
                            Return to log in
                          </a>
                        </div>
                      </div>



                      {#if errorMessage}
                        <hr />
                        <div class="notification is-danger is-light">
                          {errorMessage}
                        </div>
                      {/if}

                      {#if showSuccessMessage}
                        <hr />
                        <div class="notification is-success is-light">
                          <p>We have sent you an email with instructions.</p>
                          <p>Don't forget to check your junk folder.</p>
                          <p>Return to <a href="/">log in</a>.</p>
                        </div>
                      {/if}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hero-foot has-text-centered">
        <div class="logo" />
      </div>
    </div>
  </form>
</section>

<script lang="ts">
  import { appState } from '../../lib/appState';
  import { ga } from '@beyonk/svelte-google-analytics';
  import { params } from '@sveltech/routify';
  import { logging } from '../../lib/logging';

  let email : string;
  let errorMessage : string;

  let showSuccessMessage = false;

  if ($params.email) {
    email = $params.email;
  } 
  
  function reset() {
    window.firebase
      .auth()
      .sendPasswordResetEmail(email, {
            url: `${$appState.origin}/`,
          })
      .then(() => {
        showSuccessMessage = true;
        ga.addEvent('recover', {});
      })
      .catch((error) => {
        
        errorMessage = error.message;

        ga.addEvent('error_recover', { message: errorMessage });
        logging.report(error.toString());
      });
  }
</script>
